import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import DShieldPro_ServiceDetailsHero from "./DShieldPro_Hero";
import DShieldPro_Feature from "./DShieldPro_Feature/DShieldPro_Feature";
import DShieldPro_ServiceSection from "./DShieldPro_ServiceSection/DShieldPro_ServiceSection";
import DShieldPro_SSSlider from "./DShieldPro_SSSlider/DShieldPro_SSSlider";
import DShieldPro_Skill from "./DShieldPro_Skill/DShieldPro_Skill";
import DShieldPro_Testimonial from "./DShieldPro_Testimonial/DShieldPro_Testimonial";
import DShieldPro_Counter from "./DShieldPro_Counter/DShieldPro_Counter";
import DShieldPro_Pricing from "./DShieldPro_Pricing/DShieldPro_Pricing";
import DShieldPro_Faq from "./DShieldPro_Faq/DShieldPro_Faq";
import Footer from "../../Components/Footer/Footer";

const ServiceDetails = () => {
  return (
    <div>
      <Navbar></Navbar>
      <DShieldPro_ServiceDetailsHero></DShieldPro_ServiceDetailsHero>
      <DShieldPro_ServiceSection></DShieldPro_ServiceSection>
      <DShieldPro_Feature></DShieldPro_Feature>
      <DShieldPro_Skill></DShieldPro_Skill>
      {/* <DShieldPro_SSSlider></DShieldPro_SSSlider> */}
      <DShieldPro_Testimonial></DShieldPro_Testimonial>
      {/* <DShieldPro_Counter></DShieldPro_Counter> */}
      <DShieldPro_Faq></DShieldPro_Faq>
      {/* <DShieldPro_Pricing></DShieldPro_Pricing> */}
      <Footer></Footer>
    </div>
  );
};

export default ServiceDetails;
